import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { setPreviousUrl } from 'redux/layout/actions';

const URLHistory = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPreviousUrl(location.pathname));
  }, [dispatch, location.pathname]);

  return null;
};

export default URLHistory;
